import {useEffect, useState} from "react";
import {Button, Flex, useTheme, View} from '@aws-amplify/ui-react';
import {generateClient} from 'aws-amplify/data';
import BreakCard from "./BreakCard";
import WorkTimer from "./WorkTimer";
import './BreakCard.css';

interface BreakItem {
    id: string;
    name?: string | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    owner?: string;
}

export default function MainPage() {
    const {tokens} = useTheme();
    const [currentBreakItem, setCurrentBreakItem] = useState<BreakItem | undefined>(undefined);
    const [breakItems, setBreakItems] = useState<BreakItem[]>([]);
    const [showBreak, setShowBreak] = useState(false);

    // Create client lazily when needed
    const getClient = () => {
        const client = generateClient();
        return client as any; // Type assertion to bypass TypeScript issues
    };

    function setRandomBreakItem() {
        setCurrentBreakItem(breakItems[Math.floor(Math.random() * breakItems.length)]);
        setShowBreak(true);
    }

    useEffect(() => {
        if (!showBreak) return;
        const view = document.getElementById('breakItem');
        if (!view) return;
        view.style.animation = "spin 1s ease-out 1";
        const timer = setTimeout(() => { view.style.animation = ""; }, 1000);
        return () => clearTimeout(timer);
    }, [currentBreakItem, showBreak]);

    useEffect(() => {
        getClient().models.BreakItem.list().then(({ data }: any) => {
            setBreakItems(data);
        });
    }, []);

    return <View margin="20px auto">
        <WorkTimer onStart={() => setShowBreak(false)}/>
        <View
            borderRadius="10px"
            padding={tokens.space.medium}
            backgroundColor={tokens.colors.background.secondary}
        >
            <Flex
                direction="column"
                margin="0 auto"
                maxWidth="400px"
                justifyContent="center"
                alignItems="center"
                height="400px"
                gap={tokens.space.xxl}
            >
                {showBreak && currentBreakItem && <View id="breakItem" width="100%">
                    <BreakCard breakItem={currentBreakItem}/>
                </View>
                }
                <Button
                    width="120px"
                    variation="primary"
                    fontSize={tokens.fontSizes.xxl}
                    onClick={e => {
                        e.currentTarget.blur();
                        setRandomBreakItem();
                    }}
                    borderRadius="15px"
                >
                    Go!
                </Button>
            </Flex>
        </View>
    </View>
}